import React from "react";
import "./style.scss";

type GlobalShippingHighlightsProps = {
  globalShipping: {
    label: string;
    values: {
      text: string;
      icon: string;
    }[];
  };
};

const GlobalShipping: React.FC<GlobalShippingHighlightsProps> = ({
  globalShipping
}) => {
  if (!globalShipping) return null;
  return (
    <div className="global_shipping_highlights">
      <ul className="global_shipping_highlights_list">
        {globalShipping.values.map(attribute => (
          <li
            key={attribute.text}
            className="global_shipping_highlights_list_item"
          >
            {attribute?.icon && (
              <img
                className="global_shipping_highlights_icon"
                src={attribute.icon}
                alt="list element"
              />
            )}
            <span className="global_shipping_highlights_text">
              {attribute.text}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GlobalShipping;
